import React, { createContext, useContext, useMemo, useState } from 'react';

export const fi = {
  nav: {
    home: 'Etusivu',
    brandAgent: 'Brändiagentti',
    services: 'Palvelut',
    aiAgents: 'AI-agentit',
    websites: 'Verkkosivut',
    automations: 'Automaatiot',
    faq: 'UKK',
    about: 'Meistä',
    contact: 'Ota yhteyttä',
    bookCta: 'Varaa kartoitus',
  },
  hero: {
    eyebrow: 'Suomalainen brändiagenttistudio · Pirkanmaa',
    title: 'Brändiagentti, joka näyttää ja kuulostaa yritykseltäsi.',
    subtitle:
      'Agencive rakentaa yrityksille brändipersoonan, jota hyödynnetään somesisällöissä, sekä samaan persoonaan perustuvan AI-agentin yrityksen olemassa olevalle verkkosivustolle.',
    primaryCta: 'Varaa maksuton kartoitus',
    secondaryCta: 'Katso, miten brändiagentti toimii',
    trust: [
      'Suunniteltu pk-yrityksille',
      'Brändin mukainen toteutus',
      'Asennus olemassa olevaan sivustoon',
    ],
  },

  // NEW: brand-agent product explanation (1–4 steps)
  brandAgent: {
    eyebrow: 'Brändiagentti',
    title: 'Brändiagentti rakentuu vaiheittain',
    subtitle:
      'Agenciven brändiagentti yhdistää tunnistettavan AI-hahmon ja keskustelevan avustajan, joka asennetaan olemassa olevaan verkkosivustoosi. Lopputulos on yrityksesi brändin mukainen digitaalinen kohtaamispiste.',
    steps: [
      {
        title: 'Sosiaalinen media',
        text:
          'Luomme brändillesi tunnistettavan AI-hahmon, jota voidaan hyödyntää sisällöissä, kampanjoissa ja yrityksen näkyvyydessä.',
      },
      {
        title: 'Verkkosivun brändipersoona',
        text:
          'Sama persoona tuodaan osaksi olemassa olevaa verkkosivuasi, jossa se tekee brändistä helpommin lähestyttävän ja ohjaa kävijää eteenpäin.',
      },
      {
        title: 'Älykäs agentti',
        text:
          'Brändihahmo muuttuu keskustelevaksi AI-agentiksi, joka vastaa kysymyksiin, tunnistaa asiakkaan tarpeita ja auttaa löytämään oikean palvelun.',
      },
      {
        title: 'Konversio',
        text:
          'Agentti ohjaa kävijän kohti yhteydenottoa, tarjouspyyntöä tai muuta haluttua toimintaa — tavoitteena on vähentää kitkaa asiakaspolulla.',
      },
    ],
    ctaTitle: 'Haluatko kuulla, miltä oma brändiagenttisi voisi näyttää?',
    ctaSubtitle: 'Aloitetaan 20 minuutin maksuttomalla kartoituksella. Saat arvion sopivasta käyttötapauksesta, toteutuksesta ja seuraavista askelista.',
    cta: 'Varaa maksuton kartoitus',
  },

  // Reworked: supporting services around the brand-agent
  services: {
    eyebrow: 'Lisäpalvelut',
    title: 'Lisäpalvelut brändiagentin ympärille',
    subtitle:
      'Brändiagentti asennetaan olemassa olevalle verkkosivullesi. Ympärille voidaan rakentaa automaatiot ja sisältötuotanto, jotka syventävät asiakaskokemusta.',
    items: [
      {
        title: 'Automaatiot ja integraatiot',
        description:
          'Yhdistämme agentin lomakkeisiin, liidien keruuseen, CRM-järjestelmiin, kalenterivaraukseen ja muihin työkaluihin.',
        href: '/palvelut#automaatiot',
      },
      {
        title: 'Sisältö ja brändihahmo',
        description:
          'Suunnittelemme hahmon äänensävyn, käyttötavan ja visuaalisen roolin yrityksesi brändiin sopivaksi — sekä somessa että sivustolla.',
        href: '/palvelut#sisalto',
      },
      {
        title: 'Analytiikka ja optimointi',
        description:
          'Mittaus, integraatiot ja jatkuva optimointi sovitaan projektikohtaisesti toimituksen laajuuden mukaan.',
        href: '/palvelut#analytiikka',
      },
    ],
  },

  demo: {
    eyebrow: 'DEMO',
    title: 'Katso, miten brändiagentti auttaa asiakasta',
    subtitle:
      'Keskusteluesimerkki näyttää, miten agentti voi ohjata kävijää kohti oikeaa palvelua, yhteydenottoa tai tarjouspyyntöä.',
    cta: 'Pyydä demo',
    conversation: [
      {
        who: 'user',
        text: 'Mikä palvelu sopisi meille, jos haluamme enemmän yhteydenottoja sivuilta?',
      },
      {
        who: 'bot',
        text: 'Suosittelisin brändiagentin asentamista sivustollenne. Agentti auttaa kävijää löytämään oikean palvelun, vastaa yleisimpiin kysymyksiin ja ohjaa jättämään yhteystiedot — ilman että kävijän tarvitsee selata sivustoa uudelleen.',
      },
    ],
  },

  about: {
    title: 'Agencive AI Oy',
    subtitle: 'Meistä',
    description:
      'Brändipersoona näkyy yrityksen somesisällöissä. Samaan persoonaan perustuva AI-agentti palvelee yrityksen nykyisellä verkkosivustolla.',
    description2:
      'Uskomme, että verkkosivun tehtävä on rakentaa luottamusta, ohjata kävijää oikeaan palveluun ja tukea yhteydenottoa — ei vain esitellä yritystä.',
    team: 'Tiimimme',
  },

  faq: {
    eyebrow: 'UKK',
    title: 'Usein kysytyt kysymykset',
    subtitle:
      'Vastauksia yleisimpiin kysymyksiin brändiagenteista, integraatioista ja palvelustamme.',
    items: [
      {
        question: 'Mikä on brändiagentti?',
        answer:
          'Brändipersoona näkyy yrityksen somesisällöissä. Samaan persoonaan perustuva AI-agentti palvelee yrityksen nykyisellä verkkosivustolla. Agentti vastaa kysymyksiin, ohjaa kävijää eteenpäin ja auttaa jättämään yhteydenoton.',
      },
      {
        question: 'Onko kyseessä chatbot?',
        answer:
          'Ei pelkästään. Chatbot vastaa yleensä rajattuihin kysymyksiin. Brändiagentti suunnitellaan yrityksesi brändin, palveluiden ja asiakaspolun mukaiseksi — sillä on oma luonne, äänensävy ja visuaalinen rooli.',
      },
      {
        question: 'Voiko agenttiin liittää lomakkeita tai muita toimintoja?',
        answer:
          'Kyllä, projektikohtaisesti. Sovitaan aina yhdessä, mitkä integraatiot (esim. yhteydenottolomake, ajanvaraus, CRM) kuuluvat kyseiseen toimitukseen.',
      },
      {
        question: 'Onko brändiagentti selkeästi tekoäly?',
        answer:
          'Agentin tekoälyluonne voidaan kertoa käyttäjälle läpinäkyvästi, mutta sen tyyli, ulkoasu ja vastaukset suunnitellaan yrityksen brändiin sopiviksi.',
      },
      {
        question: 'Ketkä ovat Agenciven perustajat?',
        answer:
          'Agencive AI Oy:n perustajat ovat Lenni Marttila, Anton Ovaskainen ja Eetu Tuominen.',
      },
      {
        question: 'Kenelle palvelu sopii?',
        answer:
          'Palvelu sopii yrityksille, jotka haluavat rakentaa tunnistettavan brändipersoonan somesisältöihin ja siihen perustuvan AI-agentin nykyiselle verkkosivustolleen.',
      },
    ],
  },

  contact: {
    title: 'Ota yhteyttä',
    subtitle:
      'Haluatko selvittää, miltä oma brändiagenttisi voisi näyttää sivustollasi? Ota yhteyttä, niin katsotaan yhdessä sopiva kokonaisuus.',
    form: {
      name: 'Nimi',
      company: 'Yritys',
      email: 'Sähköposti',
      phone: 'Puhelin',
      interest: 'Kiinnostuksen kohde',
      interestPlaceholder: 'Valitse kiinnostuksen kohde…',
      interestOptions: ['Brändiagentti', 'Automaatiot', 'Sisältö & brändihahmo', 'Demo', 'En ole varma'],
      interestHelper:
        'Kerro lyhyesti tavoitteesi. Voit myös valita Demo, jos haluat nähdä käytännön esimerkin brändiagentista.',
      message: 'Viesti',
      submit: 'Lähetä viesti',
      success: 'Kiitos viestistäsi! Otamme sinuun yhteyttä mahdollisimman pian.',
      error:
        'Viestin lähetys epäonnistui. Yritä uudelleen tai lähetä sähköpostia osoitteeseen agencive.ai@gmail.com.',
      gdpr: 'Käytämme tietoja vain yhteydenottoon.',
      reply: 'Otamme sinuun yhteyttä mahdollisimman pian.',
    },
    cta: 'Varaa kartoitus',
    labels: {
      email: 'Sähköposti',
      phone: 'Puhelin',
      location: 'Sijainti',
      locationValue: 'Lempäälä · Pirkanmaa · Suomi',
    },
  },

  cta: {
    title: 'Valmis, kun olet valmis.',
    subtitle:
      'Aloitetaan 20 minuutin kartoituksella. Saat arvion sopivasta käyttötapauksesta, toteutuksesta ja seuraavista askelista.',
    button: 'Varaa maksuton kartoitus',
  },

  footer: {
    tagline: 'Brändiagentteja yrityksille',
    rights: 'Kaikki oikeudet pidätetään',
    navHeading: 'Navigointi',
    contactHeading: 'Yhteystiedot',
    links: { privacy: 'Tietosuoja', terms: 'Käyttöehdot', faq: 'UKK' },
    description: 'Suomalainen AI-studio Pirkanmaalta.',
  },

  midCTA: {
    title: 'Haluatko nähdä, miten tämä toimisi sinulla?',
    subtitle:
      'Aloitetaan 20 minuutin maksuttomalla kartoituksella. Saat arvion sopivasta käyttötapauksesta, toteutuksesta ja seuraavista askelista.',
    button: 'Varaa maksuton kartoitus',
  },

  chatLabel: 'Kysy agentilta',
  common: {
    learnMore: 'Lue lisää',
    backToHome: 'Etusivulle',
    updated: 'Päivitetty',
  },
};

// English copy is currently incomplete across legal pages, services details,
// about page and parts of the homepage. To avoid showing a mixed-language
// UI (which is worse than a single language), the EN toggle is hidden in
// the Header. Keep this `en` object as a placeholder for a future full
// translation pass — it is unused at runtime today.
const en = fi;

const translations = { fi, en };

const LanguageContext = createContext();

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};

export const LanguageProvider = ({ children }) => {
  // EN is intentionally disabled. Locking to FI prevents mixed-language pages.
  const [language] = useState('fi');
  const t = translations[language];
  // Kept as a no-op so any leftover toggle calls don't throw.
  const toggleLanguage = () => {};
  const setLanguage = () => {};
  const value = useMemo(
    () => ({ language, setLanguage, t, toggleLanguage, isLanguageSwitchEnabled: false }),
    [language, t]
  );
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
